import { render } from "./DoctorView.vue?vue&type=template&id=3a96c011&scoped=true"
import script from "./DoctorView.vue?vue&type=script&lang=js"
export * from "./DoctorView.vue?vue&type=script&lang=js"

import "./DoctorView.vue?vue&type=style&index=0&id=3a96c011&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a96c011"]])

export default __exports__